// extracted by mini-css-extract-plugin
module.exports =  {"search-icon":"_93444fe79c--search-icon--KmQvk"};